export const validatorFirstCharacterMustCapitalized = (value) => {
  const regExp = /^[A-Z]/;
  const valid = regExp.test(value);
  return valid;
};

export const validatorEndCharacterMustDots = (value) => {
  const regExp = /\.$/;
  const valid = regExp.test(value);
  return valid;
};

export const validatorExpression = (value) => {
  const regExp = /[.!?]$/;
  const valid = regExp.test(value);
  return valid;
};

export const validatorPhone = (value) => {
  const pattern =
    /^(09|01[2|6|8|9])+([0-9]{8})$|\b(07[0|6|7|8|9]|03[2|3|4|5|6|7|8|9]|08[1|2|3|4|5|6|8|9])+([0-9]{7})$|\b(02[4|8])+([0-9]{8})$|\b(021[0|1|2|3|4|5|6|8|9]|022[0|1|2|5|6|7|8|9]|023[2-9]|025[1|2|4|5|6|7|8|9]|026[0|1|2|3|9]|027[0-7]|029[0|1|2|3|4|6|7|9])+([0-9]{7})$|\b058[0-9]{7}$|\b056[0-9]{7}$|\b055[0-9]{7}$|\b087[0-9]{7}$/;
  let isValid = pattern.test(value) && value.length >= 6 && value.length <= 11;

  if (isValid === false) {
    value = value.replace(/[^0-9]/g, "");
    const pattern = /^1?[2-9][0-9]{9}$/;
    isValid = pattern.test(value);
  }

  return isValid;
};
